export default [
  {
    path: '/doubleRechargeIntroduce', name: 'doubleRechargeIntroduce', component: () => import('@/pages/doubleRecharge/introduce'), meta: { title: '翻倍充值介绍' },
  },
  {
    path: '/doubleRechargeCreate', name: 'doubleRechargeCreate', component: () => import('@/pages/doubleRecharge/create'), meta: { title: '新建活动' },
  },
  {
    path: '/doubleRechargeList', name: 'doubleRechargeList', component: () => import('@/pages/doubleRecharge/list'), meta: { title: '翻倍充值' },
  },
  {
    path: '/doubleRechargeRecord', name: 'doubleRechargeRecord', component: () => import('@/pages/doubleRecharge/record'), meta: { title: '消耗记录' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/doubleReCharge.js